import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import {
  ActivitySectionDirective,
  CallWaiterService,
  RestaurantTableService,
  UserActivityClickTrackingDirective,
} from '@core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-services-tab',
  templateUrl: './services-tab.component.html',
  styleUrls: ['./services-tab.component.scss'],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
    RouterLink,
  ],
})
export class ServicesTabComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly restaurantTable = inject(RestaurantTableService);
  public readonly callWaiterService = inject(CallWaiterService);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  public readonly table = toSignal(this.restaurantTable.table$);

  public readonly withCallWaiterMain = toSignal(this.callWaiterService.withMain$, {
    initialValue: false,
  });

  public readonly withCallWaiterAnotherRound = toSignal(this.callWaiterService.withTertiary$, {
    initialValue: false,
  });

  public readonly withCallWaiterRequestBill = toSignal(this.callWaiterService.withSecondary$, {
    initialValue: false,
  });

  public readonly callWaiterMain = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  public readonly callWaiterAnotherRound = toSignal(this.callWaiterService.tertiaryStatus$, {
    initialValue: true,
  });

  public readonly callWaiterRequestBill = toSignal(this.callWaiterService.secondaryStatus$, {
    initialValue: true,
  });

  public onClickCallWaiterMain($event: MouseEvent) {
    $event.preventDefault();
    this.callWaiterService.setMain(!this.callWaiterMain());
  }

  public onClickCallWaiterAnotherRound($event: MouseEvent) {
    $event.preventDefault();
    this.callWaiterService.setTertiary(!this.callWaiterAnotherRound());
  }

  public onClickCallWaiterRequestBill($event: MouseEvent) {
    $event.preventDefault();
    this.callWaiterService.setSecondary(!this.callWaiterRequestBill());
  }

}
